export default __webpack_public_path__ + "static/media/sircleBlueWithWhiteRing.c7e6812b.svg";